"use client";

import "../styles/global.css";
import {
  AppRouterErrorFallback,
  AppRouterGlobalErrorShell,
} from "cy-fe/src/error-handling";
import {
  type NextjsAppRouterError,
  useReportNextjsError,
} from "cy-datadog/client";

export default function GlobalError({
  error,
  reset,
}: {
  error: NextjsAppRouterError;
  reset: () => void;
}) {
  useReportNextjsError(error);

  return (
    <AppRouterGlobalErrorShell bodyClassName="text-text-100">
      <AppRouterErrorFallback reset={reset} minHeightClass="min-h-screen" />
    </AppRouterGlobalErrorShell>
  );
}
